import t from 'utils/translate';

export const _t = (path: string, options?: Record<string, string | number>) =>
	t(`common.integrations.views.${path}`, options);
